import { render, staticRenderFns } from "./CompleteBuyPointAmazonPay.vue?vue&type=template&id=c2acb6fa&scoped=true&"
import script from "./CompleteBuyPointAmazonPay.vue?vue&type=script&lang=js&"
export * from "./CompleteBuyPointAmazonPay.vue?vue&type=script&lang=js&"
import style0 from "./CompleteBuyPointAmazonPay.vue?vue&type=style&index=0&id=c2acb6fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2acb6fa",
  null
  
)

export default component.exports